import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const jwtToken = localStorage.getItem("jwt_token");

    console.log("jwtToken======>" + jwtToken);
    console.log("userData======>" + userData);

    // Si pas connecté → rediriger vers accueil
    if (userData == null || jwtToken == null) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;